import { solveChallenge } from "altcha-lib";
import { type Challenge, type Payload, type Solution } from "altcha-lib/types";
import EventEmitter from "eventemitter3";

export type CaptchaServiceStatus = "WORK" | "IDLE";

interface Events {
  status: (status: CaptchaServiceStatus) => void;
}

export class CaptchaService extends EventEmitter<Events> {
  private static instance: CaptchaService;
  private _status: CaptchaServiceStatus = "IDLE";

  static get() {
    if (this.instance) return this.instance;

    return (this.instance = new CaptchaService());
  }

  get status() {
    return this._status;
  }

  private setStatus(status: CaptchaServiceStatus) {
    this._status = status;
    this.emit("status", status);
  }

  private createPayload(data: Challenge, solution: Solution) {
    return btoa(
      JSON.stringify({
        algorithm: data.algorithm,
        challenge: data.challenge,
        salt: data.salt,
        signature: data.signature,
        number: solution.number,
        took: solution.took,
      } satisfies Payload & { took: number }),
    );
  }

  solve(challenge: Challenge) {
    this.setStatus("WORK");
    console.log("[CaptchaService] Start captcha solve...");
    console.time("[CaptchaService] solve");
    const response = solveChallenge(
      challenge.challenge,
      challenge.salt,
      challenge.algorithm,
      challenge.maxnumber,
    );

    return {
      promise: response.promise.then(async (data) => {
        this.setStatus("IDLE");
        console.timeEnd("[CaptchaService] solve");
        if (!data) return data;

        return this.createPayload(challenge, data);
      }),
    };
  }
}
